import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getWeddingBySlug, type Wedding } from 'weddings/api/weddings'

const WeddingKeys = {
  all: ['weddings'] as const,
  details: () => [...WeddingKeys.all, 'details'] as const,
  detail: (slug: string) => [...WeddingKeys.details(), slug] as const,
}

type UseWeddingOptions = Omit<
  UseQueryOptions<Wedding, unknown, Wedding, ReturnType<typeof WeddingKeys.detail>>,
  'queryKey' | 'queryFn'
>

function useWedding(
  slug?: string,
  options?: UseWeddingOptions,
): UseQueryResult<Wedding, unknown> {
  const isEnabled = !!slug && (options?.enabled ?? true)

  return useQuery({
    ...options,
    queryKey: WeddingKeys.detail(slug ?? ''),
    queryFn: () => getWeddingBySlug(slug!),
    enabled: isEnabled,
  })
}

export default useWedding
